import { Injectable } from '@angular/core';
import { DataLayerService } from './data-layer.service';
import { EcommerceEvent } from './ecommerce-event-enum';
import { buildProduct } from './build-product';
import { CURRENCY } from './currency';
import { ProductProperties } from './product-properties';

@Injectable()
export class ShoppingAnalyticsService {
  constructor(private dataLayerService: DataLayerService) {}

  trackRemoveFromCart(properties: ProductProperties): void {
    this.dataLayerService.push(EcommerceEvent.RemoveFromCart, {
      event: EcommerceEvent.RemoveFromCart,
      ecommerce: {
        currencyCode: CURRENCY,
        remove: { products: [buildProduct(properties)] },
      },
    });
  }

  trackAddToCart(properties: ProductProperties): void {
    this.dataLayerService.push(EcommerceEvent.AddToCart, {
      event: EcommerceEvent.AddToCart,
      ecommerce: {
        currencyCode: CURRENCY,
        add: { products: [buildProduct(properties)] },
      },
    });
  }
}
